import { Axios } from "@workspace/common";
import {
  BASE_DOCUMENTS,
  BASE_FORMS,
  BASE_JOBS,
  BASE_JOBS_CONADIDATE_STATE,
  BASE_JOB_TIMELINE,
  BASE_USER_GROUP,
  BASE_JOB_CUSTOM_VIEW,
  BASE_USER,
  BASE_TOS,
  BASE_PRE_OFFER_VERIFICATION,
  BASE_CONDITIONAL_OFFER,
  BASE_PRE_ASSESSMENT,
} from "./url_helper";
import {
  JOB_URL,
  DOCUMENT_URL,
  FORM_URL,
  GROUP_URL,
  API_URL,
} from "@workspace/common/src/config";

const { APIClient } = Axios;

const api = new APIClient();

//Get Form by formname
export const getFormByFormName = (formName) =>
  api.get(`${FORM_URL}${BASE_FORMS}/name/${formName}`);

// Get Job by Id
export const getJobById = (id) => api.get(`${JOB_URL}${BASE_JOBS}/${id}`);

// Get Jobs
export const getJobs = (data) =>
  api.create(`${JOB_URL}${BASE_JOBS}/listing`, data);

export const createJob = (data) =>
  api.create(`${JOB_URL}${BASE_JOBS}/add`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const cloneJob = (data) =>
  api.create(`${JOB_URL}${BASE_JOBS}/clone`, data);

export const updateJob = (id, data) =>
  api.put(`${JOB_URL}${BASE_JOBS}/${id}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const deleteJob = (id) => api.delete(`${JOB_URL}${BASE_JOBS}/${id}`);

export const deleteFOD = (id) =>
  api.delete(`${JOB_URL}${BASE_JOBS}/deleteFOD/${id}`);

export const getRecruiterByJobId = (jobId) =>
  api.get(`${JOB_URL}${BASE_JOBS}/fod/${jobId}`);

export const getJobFields = () => api.get(`${JOB_URL}${BASE_JOBS}/fields`);

export const postJobFOD = (data) =>
  api.create(`${JOB_URL}${BASE_JOBS}/jobfod`, data);

// Get Jobs
export const draftJob = () => api.get(`${JOB_URL}${BASE_JOBS}/draft`);

export const getUserGroupByName = (name) =>
  api.get(`${GROUP_URL}${BASE_USER_GROUP}/name/${name}`);

// Create Job Document

export const DOCUMENT_BASE_URL = `${DOCUMENT_URL}${BASE_DOCUMENTS}`;
export const createJobDocument = (data, config) =>
  api.create(`${DOCUMENT_BASE_URL}/add`, data, config);

export const updateJobDocument = (id, data, config) =>
  api.put(`${DOCUMENT_BASE_URL}/${id}`, data, config);

export const deleteJobDocument = (entityType, entityId) =>
  api.delete(`${DOCUMENT_BASE_URL}/entity/${entityType}/${entityId}`);

export const GET_DOCUMENT_BY_ENTITY_URL = (entityType, entityId) =>
  `${DOCUMENT_BASE_URL}/entity/user/${entityType}/${entityId}`;

export const GET_DOCUMENT_BY_ENTITY_URL_WITHOUT_USER_FILTER = (
  entityType,
  entityId
) => `${DOCUMENT_BASE_URL}/entity/${entityType}/${entityId}`;

// Get job data by Id
export const getJobDataById = (id) =>
  api.get(`${JOB_URL}${BASE_JOBS}/${id}/data/all`);

// Get job fields all
export const getJobsFieldsAll = () =>
  api.get(`${JOB_URL}${BASE_JOBS}/fields/all`);

export const getTOSFieldsAll = () =>
  api.get(`${JOB_URL}${BASE_JOBS}/tosfields/all`);

export const tagJob = (data, config) =>
  api.create(`${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}`, data, config);

export const tagAllJob = (data, config) =>
  api.create(`${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}/createAll`, data, config);

export const untagJob = (jobId, candidateId) =>
  api.delete(
    `${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}/untag/${jobId}/${candidateId}`
  );

export const getJobCandidateStage = (data) =>
  api.create(`${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}/get-stage`, data);

// Added Endpoints - Job Timeline 07052024
export const tagJobWithAttachments = (data, config) =>
  api.create(
    `${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}/create-with-attachments`,
    data,
    config
  );

export const getJobTimeline = (data) =>
  api.create(`${JOB_URL}${BASE_JOB_TIMELINE}/listing`, data);

export const getJobTimelineCount = (jobId) =>
  api.get(`${JOB_URL}${BASE_JOB_TIMELINE}/jobtimelinecount/${jobId}`);

// Updated Embeddings
export const updateJobEmbedding = (jobId) =>
  api.put(`${JOB_URL}${BASE_JOBS}/${jobId}/embedding`);

// Create Job Custom View
export const createJobCustomView = (data) =>
  api.create(`${JOB_URL}${BASE_JOB_CUSTOM_VIEW}/save/customfields`, data);

// Get Job Custom Views
export const getJobCustomViews = () =>
  api.get(`${JOB_URL}${BASE_JOB_CUSTOM_VIEW}/customView/all`);

// Select Job Custom View
export const selectJobCustomView = (id) =>
  api.put(`${JOB_URL}${BASE_JOB_CUSTOM_VIEW}/customView/update/${id}`);

// Delete Job Custom View
export const deleteJobCustomView = (id) =>
  api.delete(`${JOB_URL}${BASE_JOB_CUSTOM_VIEW}/customView/delete/${id}`);

// Delete an jobs List
export const deleteJobs = (jobIds) =>
  api.create(`${JOB_URL}${BASE_JOBS}/listing/delete`, jobIds);

// Get User by Ids
export const getUsersByIds = (userIds) =>
  api.create(`${API_URL}${BASE_USER}/find-by-ids`, userIds);

// Added Endpoints - Job Timeline 15052024
export const tagJobWithFiles = (data, config) =>
  api.create(
    `${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}/create-with-files`,
    data,
    config
  );

// Get TOS by candidate ID and Job ID
export const getTOSByJobIdAndCandidateId = (jobId, candidateId) =>
  api.get(`${JOB_URL}${BASE_TOS}/jobs/${jobId}/candidates/${candidateId}`);

// Get TOS by candidate ID and Job ID
export const getTOSByJobIdAndCandidateIdAndStatus = (
  jobId,
  candidateId,
  status
) =>
  api.get(
    `${JOB_URL}${BASE_TOS}/jobs/${jobId}/candidates/${candidateId}/status/${status}`
  );

// Get Pre-Offer Verification by candidate ID and Job ID
export const getPreOfferVerificationByJobIdAndCandidateId = (
  jobId,
  candidateId
) =>
  api.get(
    `${JOB_URL}${BASE_PRE_OFFER_VERIFICATION}/jobs/${jobId}/candidates/${candidateId}`
  );

// Get Pre-Offer Verification by candidate ID and Job ID
export const getPreOfferVerificationByJobIdAndCandidateIdAndStatus = (
  jobId,
  candidateId,
  status
) =>
  api.get(
    `${JOB_URL}${BASE_PRE_OFFER_VERIFICATION}/jobs/${jobId}/candidates/${candidateId}/status/${status}`
  );

// Get Conditional Offer by candidate ID and Job ID
export const getConditionalOfferByJobIdAndCandidateIdAndStatus = (
  jobId,
  candidateId,
  status
) =>
  api.get(
    `${JOB_URL}${BASE_CONDITIONAL_OFFER}/jobs/${jobId}/candidates/${candidateId}/status/${status}`
  );

export const updateBillRate = (data, config) =>
  api.create(`${JOB_URL}${BASE_JOB_TIMELINE}/updateBillRate`, data, config);

// Get Custom View by id
export const getJobCustomViewById = (id) =>
  api.get(`${JOB_URL}${BASE_JOBS}/customView/${id}`);

// Edit Custom View By id
export const editJobCustomViewById = (id, data) =>
  api.create(`${JOB_URL}${BASE_JOBS}/customView/edit/${id}`, data);

// Unselect all job custom View
export const unSelectAllJobCustomView = () =>
  api.put(`${JOB_URL}${BASE_JOBS}/customView/unselect-all`);

// Tos
export const getTosByJobIdAndCandidateId = (jobId, candidateId, status) =>
  api.get(
    `${JOB_URL}${BASE_TOS}/jobs/${jobId}/candidates/${candidateId}/status/${status}`
  );

// Save Job Pre-assessment Questions
export const saveJobPreAssessment = (jobPreAssessmentRequest) =>
  api.create(
    `${JOB_URL}${BASE_JOBS}/pre-assessment-questions/add`,
    jobPreAssessmentRequest
  );

// Save Job Pre-assessment Data
export const saveJobPreAssessmentData = (jobPreAssessmentDataRequest) =>
  api.create(
    `${JOB_URL}${BASE_PRE_ASSESSMENT}/add`,
    jobPreAssessmentDataRequest,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

// Get Job Pre-assessment Data
export const getJobPreAssessmentData = (preAssessmentGetRequest) =>
  api.create(
    `${JOB_URL}${BASE_PRE_ASSESSMENT}/get/data`,
    preAssessmentGetRequest
  );

// Get Job Pre-assessment Data (Public)
export const getJobPreAssessmentDataPublic = (preAssessmentGetRequest) =>
  api.create(
    `${JOB_URL}${BASE_PRE_ASSESSMENT}/get/data-public`,
    preAssessmentGetRequest
  );

// Send Pre-assessment consent email
export const sendPreAssessmentConsentEmail = (preAssessmentGetRequest) =>
  api.create(
    `${JOB_URL}${BASE_PRE_ASSESSMENT}/send/consent-email`,
    preAssessmentGetRequest
  );

// Get job Pre-assessment Video
export const getJobPreAssessmentVideo = (preAssessmentGetRequest) =>
  api.create(
    `${JOB_URL}${BASE_PRE_ASSESSMENT}/get/video`,
    preAssessmentGetRequest,
    {
      responseType: "blob",
    }
  );

// Attempt Failed interview
export const attemptFailPreAssessment = (jobPreAssessmentDataRequest) =>
  api.create(
    `${JOB_URL}${BASE_PRE_ASSESSMENT}/renew/token`,
    jobPreAssessmentDataRequest
  );

export const uploadPreOfferFilesService = (data, config) =>
  api.create(
    `${JOB_URL}${BASE_JOBS_CONADIDATE_STATE}/upload-pre-offer-files`,
    data,
    config
  );

export const callURL = (url) => api.get(url);

// Get jobs to candidate mapping
export const getJobsToCandidateMapping = (candidateId, jobId, signal) =>
  api.getWithConfig(
    `${JOB_URL}${BASE_JOBS}/${jobId}/candidate/${candidateId}/similarity`,
    { signal }
  );

// Mass Change Job Status
export const changeJobStatus = (payload) =>
  api.create(`${JOB_URL}${BASE_JOBS}/changeJobStatus`, payload);
